export interface UploadedResponse {
  fileNo: string
  basePath: string
  fileType: string
}
